import { createContext, useContext, useState, useCallback } from 'react'

const AlertContext = createContext()

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    severity: 'info',
    message: '',
    validationErrors: [],
  })

  const showAlert = useCallback(
    (message = '', severity = 'info', validationErrors = []) => {
      setAlert({ open: true, message, severity, validationErrors })
    },
    [],
  )

  const closeAlert = useCallback(() => {
    setAlert((prev) => ({ ...prev, open: false, validationErrors: [] }))
  }, [])

  return (
    <AlertContext.Provider value={{ alert, showAlert, closeAlert }}>
      {children}
    </AlertContext.Provider>
  )
}

export const useAlert = () => useContext(AlertContext)
